// extracted by mini-css-extract-plugin
module.exports = {"copyButton":"CopyInput_copyButton__ICRM2","copyButtonWrapper":"CopyInput_copyButtonWrapper__efzuu"};